const ALLOWED_REDIRECT_DOMAINS = [
  ".akitabox.com",
  ".beta-abx.com",
  ".test-abx.com",
  ".local-abx.com",
];

export function isSafeRedirectUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return false;
    }
    return ALLOWED_REDIRECT_DOMAINS.some((domain) =>
      parsed.hostname.endsWith(domain)
    );
  } catch {
    return false;
  }
}
